export const formatUserName = (assignee: { firstName?: string; lastName?: string }) =>
  [assignee.firstName, assignee.lastName].filter(Boolean).join(' ');

export default formatUserName;
